export default __webpack_public_path__ + "5220c452e4637dd9d5a01d116cafce40.png";